import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-centers-centers-dashboard',
  templateUrl: './centers-centers-dashboard.component.html',
  styleUrls: ['./centers-centers-dashboard.component.scss']
})
export class CentersCentersDashboardComponent implements OnInit, OnDestroy {

  centers;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  searchCentersSubscription: Subscription;
  filterCentersSubscription: Subscription;
  getCentersSubscription: Subscription;
  toggleCentersDispositionSubscription: Subscription;
  refreshCentersSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private cd: ChangeDetectorRef,
              private snackbarService: SnackBarService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCenters();
    this.refreshCentersSubscription = this.centersCentersService.refreshCenterListen().subscribe(() => this.getCenters());
    this.filterCentersSubscription = this.centersCentersService.filterCentersListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchCentersSubscription = this.centersCentersService.searchCentersListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleCentersDispositionSubscription = this.centersCentersService.toggleCentersDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getCenters() {
    this.getCentersSubscription = this.centersCentersService.getCenters().pipe(
      tap(o => this.centers = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-store-alt', 'stores-page.store locator'));
  }

  private setNoItemsConfig() {
    return {
      description: 'stores-page.stores not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.searchCentersSubscription) { this.searchCentersSubscription.unsubscribe(); }
    if (this.filterCentersSubscription) { this.filterCentersSubscription.unsubscribe(); }
    if (this.getCentersSubscription) { this.getCentersSubscription.unsubscribe(); }
    if (this.toggleCentersDispositionSubscription) { this.toggleCentersDispositionSubscription.unsubscribe(); }
    if (this.refreshCentersSubscription) { this.refreshCentersSubscription.unsubscribe(); }
  }
}
